package com.shadowings.gero.data.lessons.chapter4
import com.shadowings.gero.data.lessons.buildVocabContent
import com.shadowings.gero.data.lessons.buildVocabQuizContent


import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.ImageKeyboardContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.amenamhat
import gero.composeapp.generated.resources.exp_content_royal_names_full_intro
import gero.composeapp.generated.resources.exp_content_royal_names_full_tap_image
import gero.composeapp.generated.resources.exp_content_royal_names_img_amenemhat
import gero.composeapp.generated.resources.exp_content_royal_names_img_mentuhotep
import gero.composeapp.generated.resources.exp_content_royal_names_img_neferhotep
import gero.composeapp.generated.resources.exp_content_royal_names_img_tutankhamon
import gero.composeapp.generated.resources.exp_content_royal_names_img_tutankhamon2
import gero.composeapp.generated.resources.lesson_royal_names_full_title
import gero.composeapp.generated.resources.mentuhotep
import gero.composeapp.generated.resources.neferhotep
import gero.composeapp.generated.resources.tutankhamon
import gero.composeapp.generated.resources.tutankhamon2

private val royalFullNameWordIds = listOf("NFRHTP", "AMENEMHAT", "TUTANKHAMUN", "MENTUHOTEP")

fun getRoyalNamesFullContent(
    words: List<Word>,
    languageCode: String
): List<IExplanation> {
    val vocabSlides = buildVocabContent(
        lessonTitle = Res.string.lesson_royal_names_full_title,
        lessonIntro = Res.string.exp_content_royal_names_full_intro,
        wordIds = royalFullNameWordIds,
        words = words,
        languageCode = languageCode
    )

    val imageSlides = listOf(
        ExplanationContent(
            title = Res.string.lesson_royal_names_full_title,
            content = Res.string.exp_content_royal_names_full_tap_image,
            face = Faces.Happy
        ),
        ExplanationContent(
            title = Res.string.lesson_royal_names_full_title,
            content = Res.string.exp_content_royal_names_img_amenemhat,
            face = Faces.Serious,
            image = Res.drawable.amenamhat,
            imageSize = 0.75f,
            applyFilter = false,
            fullscreenable = true
        ),
        ExplanationContent(
            title = Res.string.lesson_royal_names_full_title,
            content = Res.string.exp_content_royal_names_img_mentuhotep,
            face = Faces.Serious,
            image = Res.drawable.mentuhotep,
            imageSize = 0.75f,
            applyFilter = false,
            fullscreenable = true
        ),
        ExplanationContent(
            title = Res.string.lesson_royal_names_full_title,
            content = Res.string.exp_content_royal_names_img_neferhotep,
            face = Faces.Serious,
            image = Res.drawable.neferhotep,
            imageSize = 0.75f,
            applyFilter = false,
            fullscreenable = true
        ),
        ExplanationContent(
            title = Res.string.lesson_royal_names_full_title,
            content = Res.string.exp_content_royal_names_img_tutankhamon,
            face = Faces.Serious,
            image = Res.drawable.tutankhamon,
            imageSize = 0.75f,
            applyFilter = false,
            fullscreenable = true
        ),
        ExplanationContent(
            title = Res.string.lesson_royal_names_full_title,
            content = Res.string.exp_content_royal_names_img_tutankhamon2,
            face = Faces.Serious,
            image = Res.drawable.tutankhamon2,
            imageSize = 0.75f,
            applyFilter = false,
            fullscreenable = true
        )
    )

    return vocabSlides + imageSlides
}

// Cartouche photos from the lesson (image code, word id). Only the name inside the cartouche is
// transcribed: the epithets on Mentuhotep ("sꜣ rꜥ") and Tutankhamun ("ḥqꜣ iwnw šmꜥ") are left out,
// and the caption shown as feedback mentions them.
private val royalCartouches = listOf(
    Triple("amenamhat", "AMENEMHAT", Res.string.exp_content_royal_names_img_amenemhat),
    Triple("mentuhotep", "MENTUHOTEP", Res.string.exp_content_royal_names_img_mentuhotep),
    Triple("neferhotep", "NFRHTP", Res.string.exp_content_royal_names_img_neferhotep),
    Triple("tutankhamon", "TUTANKHAMUN", Res.string.exp_content_royal_names_img_tutankhamon),
    Triple("tutankhamon2", "TUTANKHAMUN", Res.string.exp_content_royal_names_img_tutankhamon2),
)

fun getRoyalNamesFullQuizContent(
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val vocabQuizzes = buildVocabQuizContent(
        explanations = getRoyalNamesFullContent(words = words, languageCode = languageCode),
        words = words,
        languageCode = languageCode
    )
    // words.tsv spells some of these readings with capital Ꜣ/Ꜥ; the keyboard only has lowercase.
    val cartoucheQuizzes = royalCartouches.mapNotNull { (imageCode, wordId, caption) ->
        val word = words.firstOrNull { it.id == wordId } ?: return@mapNotNull null
        ImageKeyboardContent(
            imageCode = imageCode,
            reading = word.reading.lowercase().map { it.toString() },
            translation = caption
        )
    }
    return (vocabQuizzes + cartoucheQuizzes).shuffled()
}

